/*
 * Subtle reveal-on-scroll for product-page sections that do not ship their own motion.
 * Tags the heading / copy blocks listed below, then fades them up as they enter the viewport.
 * Elements already on screen at load are shown immediately (no flash). Respects reduced motion.
 */
(function () {
  if (window.__pagPdpMotion) return;
  window.__pagPdpMotion = true;

  var SELECTORS = [
    '.pag-pdp-tech__head',
    '.pag-pdp-tech__viewport',
    '.pag-pdp-band__body',
    '.pag-steps__heading',
    '.pag-product-showcase-heading',
    '.pag-product-showcase-carousel',
    '.pag-recently-viewed__head'
  ];

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Sections that ship their own GSAP reveal ([data-pag-reveal], e.g. the recommendation rows) are left alone:
  // two animations on one heading leave it stuck at opacity 0.
  var els = [].slice.call(document.querySelectorAll(SELECTORS.join(','))).filter(function (el) {
    return !el.closest('[data-pag-reveal]');
  });
  if (!els.length) return;

  els.forEach(function (el) {
    var sibs = [].filter.call(el.parentNode.children, function (c) {
      return els.indexOf(c) > -1;
    });
    el.style.setProperty('--pdp-fx-d', Math.min(sibs.indexOf(el), 4) * 80 + 'ms');
  });

  function show(el) {
    el.classList.add('pdp-fx', 'is-in');
  }

  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(show);
    return;
  }

  var vh = window.innerHeight;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );

  els.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < vh * 0.9 && r.bottom > 0) {
      show(el); // already on screen: no hide-then-show flash
    } else {
      el.classList.add('pdp-fx');
      io.observe(el);
    }
  });
})();
